import { httpRequest } from "@/utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";

//物料信息
export interface ISCmphotoMd5 {
    photoMd5: string
}

export interface IImportParams {
    "msg": string,  // "导入成功!",

}
export interface IWarehouseMaterialDetal {
    id?: string, // "",
    materialCode?: string, // "",
    materialName?: string, // "",
    purchasePrice?: number, // 0,
    repairPrice?: number, // 0,
    shelfCode?: string, // "",
    shelfId?: string, // "",
    shopId?: string, // "",
    shopName?: string, // "",
    warehouseCode?: string, // "",
    warehouseId?: string, // "",
    warehouseName?: string, // ""
}
//详情
export interface IMaterialBase {
    brandCode: string,               // "",
    brandName: string,               // "",
    code: string,               // "",
    createTime: string,               // "",
    createUser: string,               // "",
    deleteFlag: number,               // 0,
    engineType: string,               // "",
    id: string,               // "",
    inventoryNum: number,               // 0,
    limitLower: number,               // 0,
    limitUpper: number,               // 0,
    madeFrom: string,               // "",
    model: string,               // "",
    name: string,               // "",
    nameEn: string,               // "",
    note: string,               // "",
    orderNum: number,               // 0,
    purchasePrice: number,               // 0,'
    latestPurPrice: number,
    replaceCode: string,               // "",
    retailPrice: number,               // 0,
    shelfCode: string,               // "",
    shelfId: string,               // "",
    status: string | number | boolean,               // 0,
    typeCode: string,               // "",
    typeName: string,               // "",
    unitCode: string,               // "",
    unitName: string,               // "",
    updateTime: string,               // "",
    updateUser: string,               // "",
    warehouseCode: string,               // "",
    warehouseId: string,               // "",
    warehouseName: string,               // "",
    wholesalePrice: number,               // 0     
    materialCode?: string,
    materialName?: string,
    materialNameEn?: string,
    price?: number,
    enable?: number,
    minOrderNum?: number,
    materialDetal?: IWarehouseMaterialDetal[],
    materialShelfVo?: {
        materialCode?: string,  // "5802352788"
        materialName?: string,  // "中间传动轴"
        shelfCode?: string,  // "201-01-01"
        shelfId?: string,  // "55437cecc75968fc26290f0715038dba"
        shopId?: string,  // "18059196cb7c4829ac35f23329ba2256"
        warehouseCode?: string,  // "WH-M-00000013"
        warehouseName?: string,  // "天津红岩库"
    }
    [key: string]: any
}

export interface IMaterialDetail extends IMaterialBase {
    // photo: ISCmphotoMd5[],
}

//新增
export interface IFormGoodsFields extends IMaterialBase {
    photo: string
}

//搜索条件
export interface IMaterialSearchFields {
    code?: string,
    name?: string,
    replaceCode?: string,
    typeCode?: string,
    engineType?: string,
    orderStatus?: string,
    shopId?: string,
}

export interface IMaterialSearch
    extends IMaterialSearchFields, ISearchPage {

}

//采购物料查询searchVo
export interface IPurchaseMaterialSearch extends ISearchPage {
    codeOrName: string
}
//采购物料查询details
export interface IurchaseMaterialDetails {
    id: string,
    materialId: string,
    code: string,
    name: string,
    replaceCode: string,
    unitCode: string,
    brandCode: string,
    typeCode: string,
    retailPrice: number,
    wholesalePrice: number,
    distributorPrice: number,
    repairPrice: number,
    warehouseId: string,
    warehouseName: string,
    shelfId: string,
    shelfCode: string,
    inventoryNum: number,
}
export interface paramsDisable {
    id: string,
    enable: number
}
class MaterialService {
    async page(searchVo: IMaterialSearch) {
        const apiUrl = "/zzw-vrm/base/material/findPage";
        return await httpRequest.post<IPage<IMaterialDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/base/material/findById/${id}`;
        return await httpRequest.get<IMaterialDetail>(apiUrl);
    }
    async onePicture(code: string, shopId: string) {
        const apiUrl = `/zzw-vrm/base/material/findByCode/${code}/${shopId}`;
        return await httpRequest.get<IMaterialDetail>(apiUrl);
    }
    async endEnquiry(code: string) {
        const apiUrl = `/zzw-vrm/base/material/offerTimeEnd/${code}`;
        return await httpRequest.get<any>(apiUrl);
    }
    async insert(insertVo: IFormGoodsFields) {
        const apiUrl = "/zzw-vrm/base/material/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IFormGoodsFields) {
        const apiUrl = "/zzw-vrm/base/material/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(params: object) {
        const apiUrl = `/zzw-vrm/base/material/change`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/zzw-vrm/base/material/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IMaterialSearch) {
        const appPageUrl = "/zzw-vrm/base/material/export";
        return await httpRequest.postFile(appPageUrl, searchVo, { timeout: 300000 });
    }
    //分页查询物料列表-用于采购
    async findPageByPurchase(searchVo: IurchaseMaterialDetails) {
        const appPageUrl = `/zzw-vrm/base/material/findPageByPurchase`;
        return await httpRequest.post<IPage<IurchaseMaterialDetails>>(appPageUrl);
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/zzw-vrm/base/material/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
    //物料导入图片
    async importImg(file: { file: File }) {
        const appPageUrl = "/zzw-vrm/base/material/importImg";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }

    // 配件价格导入
    async priceImport(file: { file: File }) {
        const appPageUrl = "/zzw-vrm/base/material/importPrice";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }

    // 配件价格导入模板下载
    async priceDownloadTpl() {
        const appPageUrl = "/zzw-vrm/base/material/downloadPriceTpl";
        return await httpRequest.getFile(appPageUrl);
    }

    async findDetailByCodes(codes: string[]) {
        const apiUrl = "/zzw-vrm/base/material/findByCodes";
        return await httpRequest.post<IMaterialDetail[]>(apiUrl, codes);
    }
}

export const materialService = new MaterialService();